<template>
  <div>
    <form id="formSiteSetupAppearance" @change="clearErrors()" class="d-flex flex-column align-items-center" v-on:submit.prevent="updateSiteAppearanceSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Appearance</h5>
                  <div class="element-inner-desc">Here you can change the site appearance settings.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'paint-brush']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Appearance</h5>
                  <div class="element-inner-desc">Here you can change the site appearance settings.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Upload new logo</h5>
              <h5 v-else class="py-2 text-center">Upload new logo</h5>
            </div>
          </div>
          <div class="row pb-2">
            <p v-if="!setupSiteAppearance.navbarLogoImage" class="mt-3 col-lg-6 col-sm-12">No logo has been uploaded</p>
            <div v-else class="col-lg-6 col-sm-12 image-container">
                <b-img v-if="!this.mobile" @error="imageError()" :src="setupSiteAppearance.navbarLogoImage + '?' + this.cacheValue"></b-img>
                <b-img v-else css="logo-mobile" @error="imageError()" :src="setupSiteAppearance.navbarLogoImage + '?' + this.cacheValue" width="80%"></b-img>
            </div>
            <b-form-group class="col-lg-6 col-sm-12 mt-0 align-self-start">
              <b-form-file
                id="navbar-logo"
                accept=".jpg, .png"
                v-model="inputAppearanceImage.navbarLogoImage"
                placeholder="Choose a file or drop it here ..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div v-if=" inputAppearanceImage.navbarLogoImage && (typeof  inputAppearanceImage.navbarLogoImage == 'object')" class="mt-1 file-upload">
                <span v-if=" inputAppearanceImage.navbarLogoImage.name">
                  <fontAwesomeIcon :icon="['fas', 'file-image']" size="1x" />
                  <span class="pl-1"> {{  inputAppearanceImage.navbarLogoImage.name }} </span>
                  <span v-if=" inputAppearanceImage.navbarLogoImage.size > 1000000" class="pl-2 text-danger">the file is too big ( {{  inputAppearanceImage.navbarLogoImage.size }} bytes)</span>
                  <span v-else class="text-primary">selected</span>
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="row pb-2">
            <p v-if="!setupSiteAppearance.navbarBackgroundImage" class="mt-3 col-lg-6 col-sm-12">No background image has been uploaded</p>
            <div v-else class="col-lg-6 col-sm-12 image-container" id="background-image-container">
                <img id="background-img" @error="imageError()" v-if="!this.mobile" :src="setupSiteAppearance.navbarBackgroundImage + '?' + this.cacheValue">
                <img id="background-img" @error="imageError()" v-else css="logo-mobile" :src="setupSiteAppearance.navbarBackgroundImage + '?' + this.cacheValue" width="80%">
            </div>
            <b-form-group class="col-lg-6 col-sm-12 mt-0 align-self-start">
              <b-form-file
                id="navbar-background"
                accept=".jpg, .png"
                v-model="inputAppearanceImage.navbarBackgroundImage"
                placeholder="Choose a file or drop it here ..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div v-if=" inputAppearanceImage.navbarBackgroundImage && (typeof  inputAppearanceImage.navbarBackgroundImage == 'object')" class="mt-1 file-upload">
                <span v-if=" inputAppearanceImage.navbarBackgroundImage.name">
                  <fontAwesomeIcon :icon="['fas', 'file-image']" size="1x" />
                  <span class="pl-1"> {{  inputAppearanceImage.navbarBackgroundImage.name }} </span>
                  <span v-if=" inputAppearanceImage.navbarBackgroundImage.size > 4000000" class="pl-2 text-danger">the file is too big ( {{  inputAppearanceImage.navbarBackgroundImage.size }} bytes)</span>
                  <span v-else class="text-primary">selected</span>
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Change color settings</h5>
              <h5 v-else class="py-2 text-center">Change color settings</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Layout</span>
                   </b-input-group-text>
                </b-input-group-prepend>
              <b-form-select class="text-capitalize" @change="layoutChanger($event)" v-model="setupSiteAppearance.layout.layout">
                <option value="normal">normal</option>
                <option value="custom">custom</option>
              </b-form-select>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Header Background</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-if="setupSiteAppearance.layout.layout == 'custom'" class="text-uppercase" v-model="setupSiteAppearance['colours'].colour_header_bg" @input="updateHeaderColour(setupSiteAppearance['colours'].colour_header_bg)"></b-form-input>
                <span v-else class="form-control disabled-field text-uppercase" >#047bf8</span>
                <b-input-group-append v-if="setupSiteAppearance.layout.layout == 'custom'">
                  <b-form-input v-model="setupSiteAppearance['colours'].colour_header_bg" @input="updateHeaderColour(setupSiteAppearance['colours'].colour_header_bg)" type="color" class="d-inline-block h-auto p-0 color-picker"></b-form-input>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <span style="background-color: #047bf8;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Navigation Bar</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-if="setupSiteAppearance.layout.layout == 'custom'" class="text-uppercase" v-model="setupSiteAppearance.colours['colour_nav_bg']"  @input="updateNavbarColour(setupSiteAppearance['colours'].colour_nav_bg)"></b-form-input>
                <span v-else class="form-control disabled-field text-uppercase" >#047bf8</span>
                <b-input-group-append v-if="setupSiteAppearance.layout.layout == 'custom'">
                  <b-form-input v-model="setupSiteAppearance.colours['colour_nav_bg']" @input="updateNavbarColour(setupSiteAppearance['colours'].colour_nav_bg)" type="color" class="d-inline-block h-auto p-0 color-picker"></b-form-input>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <span style="background-color: #047bf8;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Navigation Text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-if="setupSiteAppearance.layout.layout == 'custom'" class="text-uppercase" v-model="setupSiteAppearance.colours['colour_nav_text']" @input="updateNavbarTextColour(setupSiteAppearance['colours'].colour_nav_text)"></b-form-input>
                <span v-else class="form-control disabled-field text-uppercase" >#ffffff</span>
                <b-input-group-append v-if="setupSiteAppearance.layout.layout == 'custom'">
                  <b-form-input v-model="setupSiteAppearance.colours['colour_nav_text']" @input="updateNavbarTextColour(setupSiteAppearance['colours'].colour_nav_text)" type="color" class="d-inline-block h-auto p-0 color-picker"></b-form-input>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <span style="background-color: #ffffff;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Sub Menu Text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-if="setupSiteAppearance.layout.layout == 'custom'" class="text-uppercase" v-model="setupSiteAppearance.colours['colour_menu_text']" @input="updateSubmenuTextColour(setupSiteAppearance['colours'].colour_menu_text)"></b-form-input>
                <span v-else class="form-control disabled-field text-uppercase" >#ffffff</span>
                <b-input-group-append v-if="setupSiteAppearance.layout.layout == 'custom'">
                  <b-form-input v-model="setupSiteAppearance.colours['colour_menu_text']" @input="updateSubmenuTextColour(setupSiteAppearance['colours'].colour_menu_text)" type="color" class="d-inline-block h-auto p-0 color-picker"></b-form-input>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <span style="background-color: #ffffff;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Sub Menu Active Text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Sub Menu</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-if="setupSiteAppearance.layout.layout == 'custom'" class="text-uppercase" v-model="setupSiteAppearance.colours['colour_menu_inner']" @input="updateSubmenuColour(setupSiteAppearance['colours'].colour_menu_inner)"></b-form-input>
                <span v-else class="form-control disabled-field text-uppercase" >#1b55e2</span>
                <b-input-group-append v-if="setupSiteAppearance.layout.layout == 'custom'">
                  <b-form-input v-model="setupSiteAppearance.colours['colour_menu_inner']" @input="updateSubmenuColour(setupSiteAppearance['colours'].colour_menu_inner)" type="color" class="d-inline-block h-auto p-0 color-picker"></b-form-input>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <span style="background-color: #1b55e2;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Sub Menu border</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Active sub menu</span></b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Pagination & footer</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Notification</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Notification colour</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Active tab background</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Active tab text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Inactive tab background</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Inactive tab text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Table Header</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Table Header Text</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field text-uppercase" >NOT USED</span>
                <b-input-group-append>
                  <span style="background-color: #e9ecef;" class="form-control d-inline-block h-auto p-0 color-picker"></span>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
           <transition name="fade">
            <ValidationErrors v-if="getValidationErrors.validationName == 'colourFormatError'" class="mt-3"/>
          </transition>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupAppearance'" class="mt-3"/>
          </transition>
            <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupAppearance',
  components:{
    ResponseInfo,
    ValidationErrors
  },
  data() {
    return {
      setupSiteAppearance: {
        layout: {
          layout: ''
        },
        colours: {}
      },
      inputAppearanceImage: {},
      missingImage: false,
      cacheValue: new Date().getTime(),
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    /*
    siteAppearanceSettings:{
        this.$store.dispatch('getSiteAppearanceSettings')
        .then(() => {
            this.hashtagCorrector(this.siteAppearanceSettings.colours)
            this.setupSiteAppearance = this.siteAppearanceSettings
        })

    }*/
    this.$store.dispatch('getSiteAppearanceSettings')
    .then(() => {
      this.setupSiteAppearance = this.siteAppearanceSettingsWithHash
    })

    window.addEventListener('resize', () => {
      this.mobile = window.innerWidth <= 700
    })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getSiteAppearanceSettings', 'getResponseInfo', 'getValidationErrors']),
      appearanceSettings: {
          get() {
              return this.$store.getters.getSiteAppearanceSettings
          }
      },
      siteAppearanceSettingsWithHash(){
        //let appearanceSettings = this.appearanceSettings
        //this.hashtagCorrector(appearanceSettings.colours)
        this.appearanceSettings.colours = this.hashtagOn(this.appearanceSettings.colours)
        return this.appearanceSettings
      },
      loginStatus: {
        get() {
            return this.$store.getters.getUserDetails.loginStatus
        }
      }
  },
  methods: {
    update() {
      this.cacheValue = new Date().getTime()
    },
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    imageError() {
      this.missingImage = true
    },
    updateSiteAppearanceSettings() {
      this.navbarLogo = document.getElementById('navbar-logo').files[0]
      this.navbarBackground = document.getElementById('navbar-background').files[0]
      let formData = new FormData()

      let colours = this.setupSiteAppearance.colours
      colours = this.hashtagOff(colours)
      this.inputAppearanceImage.colours = colours

      this.inputAppearanceImage.layout = this.setupSiteAppearance.layout.layout

      this.inputAppearanceImage.userId = this.getUserDetails.id
      if(Object.keys(this.inputAppearanceImage).length){
        for (let [key, value] of Object.entries(this.inputAppearanceImage)) {
            if(key == 'navbarLogoImage'){
              formData.append('navbarLogoImage', this.navbarLogo)
            }else if(key == 'navbarBackgroundImage'){
              formData.append('navbarBackgroundImage', this.navbarBackground)
            }else if(key == 'colours'){
              let colorValues = JSON.stringify(this.inputAppearanceImage.colours)
              formData.append('colours', colorValues)
            }else{
              formData.append(key, value)
            }
        }

        this.$store.dispatch('setSiteAppearanceSettings', formData
        ).then(() => {
            //this.hashtagCorrector(this.setupSiteAppearance.colours)
            this.$store.dispatch('getSiteAppearanceSettings')

            setTimeout( () => {
              this.update()
              this.inputAppearanceImage.navbarLogoImage = []
              this.inputAppearanceImage.navbarBackgroundImage = []
              //we need to access the "Settings" component, and it's very high in the family tree
              //this way we can trigger the navbar logo to refresh
              this.$parent.$parent.$parent.$parent.$refs.navbar.update()
              this.$parent.$parent.$parent.$parent.$refs.navbar.applyBackground()
            } , 500)
        })
      }
      this.$store.dispatch('getSiteAppearanceSettings')
      .then(() => {
        this.setupSiteAppearance = this.siteAppearanceSettingsWithHash
      })

    },
    hashtagCorrector(colours) {
        if(colours){
          if(Object.keys(colours).length){
            for (let [key, value] of Object.entries(colours)) {
                if(!value.includes('#')){
                    colours[key] = '#' + value
                }else{
                    colours[key] = value.replace(/#/, '')
                }
            }

            Object.defineProperty(this.setupSiteAppearance, 'colours', {value: colours})
          }
        }
    },
    hashtagOff(colours) {
      if(colours){
        if(Object.keys(colours).length){
          for (let [key, value] of Object.entries(colours)) {
            colours[key] = value.replace(/#/, '')
          }

          return colours
        }
      }
    },
    hashtagOn(colours) {
      if(colours){
        if(Object.keys(colours).length){
          for (let [key, value] of Object.entries(colours)) {
            colours[key] = '#' + value
          }

          return colours
        }
      }
    },
    layoutChanger(event) {
      this.$store.commit('setLayout', event)
    },
    updateHeaderColour(colour) {
      this.$store.commit('setHeaderBackground', colour)
    },
    updateNavbarColour(colour) {
      this.$store.commit('setNavbarColour', colour)
    },
    updateNavbarTextColour(colour) {
      this.$store.commit('setNavbarTextColour', colour)
    },
    updateSubmenuTextColour(colour) {
      this.$store.commit('setSubmenuTextColour', colour)
    },
    updateSubmenuColour(colour) {
      this.$store.commit('setSubmenuColour', colour)
    }
  },
  beforeDestroy() {
      // beforeDestroy also gets called when we logout from the site setup page,
      // so we only need to reset the colours if we are still logged in
      if(this.$store.getters.loggedIn){
          // Reset the layout colours from DB on leaving the page
          this.$store.dispatch('getSiteAppearanceSettings')
      }
  }
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.h-auto{
  height:auto;
}
.color-picker{
  width: 40px;
}
.pretext{
  display: flex;
  align-items: center;
  justify-content: center;
}
.pretext-span{
  width: 100%;
  white-space: normal;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.disabled-field{
  background-color: rgb(233, 236, 239);
}
.image-container img{
  max-height: 120px;
}
#background-image-container{
  overflow: hidden;
}
</style>
